import React, { useContext, useState, useEffect } from "react";
import Card from './UI/Card';
import profile from '../assets/logoufm1.png';
import AuthContext from '../context/auth-context';
import { AppContext } from "../services/AppContext";
import useGetInfoPersonal from "../hooks/useGetInfoPersonal";
import useGetFechaAdmisionElegida from "../hooks/useGetFechaAdmisionElegida";


const Perfil = () => {
    const authContext = useContext(AuthContext);

    const {appValues} = useContext(AppContext);

    const infoPersonal = useGetInfoPersonal(authContext.token);

    const fechaAdmisionElegidaData = useGetFechaAdmisionElegida(authContext.token);

    const [ nombre, setNombre ] = useState('');
    const [ programa , setPrograma ] = useState('');
    const [ fechaAdmisionElegida, setFechaAdmisionElegida ] = useState('');

    useEffect(() => {
        setNombre(infoPersonal.nombre);
        setPrograma(infoPersonal.programa);
        setFechaAdmisionElegida(fechaAdmisionElegidaData.fecha_char);
    }, [infoPersonal,fechaAdmisionElegidaData]);

    const estadoExamenAplicante = appValues.examenAplicante ? "completado" : "pendiente";

    const profileBorderColor = appValues.perfil === 100 && appValues.pagoAdmision === 'APROBADA' ? "border-success" : "border-light";
    const progressBarValue = appValues.perfil > 10 ? appValues.perfil : 10;
    
    let progressBarColor = "secondary";
    if(appValues.perfil >= 1 && appValues.perfil <= 9){
        progressBarColor = "danger";
    } else if (appValues.perfil >= 10 && appValues.perfil <= 49){
        progressBarColor = "warning";
    } else if (appValues.perfil >= 50 && appValues.perfil <= 100){
        progressBarColor = "success";
    }

    return (
        <Card style={{borderRadius: '20px 0px 0px 20px', backgroundColor: 'white !important'}} className="h-100">
            <div className="card-body text-center user-select-none">
                {/* FOTO DE PERFIL */}
                <img 
                    src={profile} 
                    draggable="false" 
                    className={`rounded-circle ${profileBorderColor} w-50 shadow border border-4 my-3`}
                    width="120"
                    height="120"
                    alt="Placeholder profile"></img>
                    
                {/* NOMBRE */}
                <div className='lead' style={{fontWeight: "500"}}>
                    { nombre }
                </div>

                {/* PORCENTAJE DE PERFIL COMPLETADO */}
                <div className="progress shadow-sm mt-5 bg-light">
                    <div 
                        className={`progress-bar bg-${progressBarColor}`} 
                        role="progressbar" 
                        aria-valuenow={progressBarValue} 
                        aria-valuemin="0" 
                        aria-valuemax="100" 
                        style={{width: progressBarValue+'%'}}>{appValues.perfil}%</div>
                </div>
                <div className='fw-light text-black-50'>% Perfil completado</div>

                <hr className='my-4' />

                <h5>Programa</h5>
                <h5><span className="badge rounded-pill text-bg-dark fw-light shadow-sm text-wrap">{ programa }</span></h5>
                <br />
                {/*<h5>Entrevista de admisión</h5>*/}
                <h5>Examen de admisión</h5>
                            
                 <div>Fecha: <span  
                 className={`fst-italic text-${ estadoExamenAplicante  === 'completado' ? 'success':'danger' }`}>
                    <strong>
                    { estadoExamenAplicante === 'completado' ? `${fechaAdmisionElegida}`:'Pendiente' }
                    </strong>
                    </span></div>
                    
                <div>Pago: <span style={{ fontSize: '0.85rem', fontWeight: '200' }} className={`badge rounded-pill text-bg-${ appValues.pagoAdmision === 'APROBADA' ? 'success':'danger' }`}>{ appValues.pagoAdmision === 'APROBADA' ? 'APROBADO':'PENDIENTE' }</span></div>
                
            </div>
        </Card>
    );
};

export default Perfil;